import React from "react"

import { Container } from "@components/grid"

import { Panel, ImageWrapper, SpacedTop } from "./styles"

export const OverlapPanel = props => (
  <SpacedTop {...props}>
    <Container maxWidth={props.maxWidth}>{props.children}</Container>
  </SpacedTop>
)

export const ImagePanel = props => (
  <ImageWrapper position={props.position} fluid={props.image}>
    {props.children}
  </ImageWrapper>
)

export default props => (
  <Panel {...props}>
    <Container maxWidth={props.maxWidth}>{props.children}</Container>
  </Panel>
)
